import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { KIRA_LOCAL_STORAGE_NAME, TRANSLATION_NAMESPACES } from './constant';

const translationPath = `${process.env.REACT_APP_TRANSLATION_SERVICE_ENDPOINT}/{{lng}}/{{ns}}.{{lng}}.json`;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: [
      TRANSLATION_NAMESPACES.COMMON,
      TRANSLATION_NAMESPACES.NOTIFICATION_CODES
    ],
    fallbackLng: false,
    fallbackNS: TRANSLATION_NAMESPACES.COMMON,
    defaultNS: TRANSLATION_NAMESPACES.COMMON,
    interpolation: {
      escapeValue: false
    },
    detection: {
      caches: ['localStorage'],
      order: ['localStorage'],
      lookupLocalStorage: KIRA_LOCAL_STORAGE_NAME
    },
    backend: {
      loadPath: translationPath,
      parse: parseResponse,
      requestOptions: {
        mode: 'cors',
        credentials: 'same-origin',
        cache: 'reload'
      }
    }
  });

function parseResponse(data, language, namespace) {
  let translationData = {};

  try {
    const jsonData = typeof data === 'string' ? JSON.parse(data) : data;
    if (Object.prototype.hasOwnProperty.call(jsonData, namespace)) {
      translationData = jsonData[namespace];
    } else {
      translationData = jsonData;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`parseResponse: ${error.message}`);
  }

  return translationData;
}

export default i18n;
